import { Tooltip } from '@mui/material';
import { ExtendedTypography } from '@issuemanager/apps/client/components';
import styled from '@emotion/styled';
import { useRef, useState, useEffect } from 'react';

const StyledSpan = styled('span')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type Props = {
  value: string;
};

export function FieldWithTooltip({ value }: Props) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const span = spanRef.current;
    if (span) {
      setIsOverflowing(span.scrollWidth > span.clientWidth);
    }
  }, [value]);

  return (
    <Tooltip
      title={
        isOverflowing ? (
          <ExtendedTypography variant='textSm'>{value}</ExtendedTypography>
        ) : (
          ''
        )
      }
      disableHoverListener={!isOverflowing}
    >
      <StyledSpan ref={spanRef}>{value}</StyledSpan>
    </Tooltip>
  );
}
